import $ from 'jquery'
import ClipboardJS from 'clipboard'
import config from 'modules-core/config'
import log from 'modules-core/log'
import player from 'modules-core/player'
import { MUTE_TOGGLE_VOLUME_APPLY } from 'modules-core/audioSystem/audioSystem'
import syrinscape from 'app/common/syrinscape'
import visualisation from 'modules-core/visualisation'
import { eventSystem } from 'modules-core/eventSystem'

const logger = log.getLogger('basicPlayer')

$(document).on('click', '.new-session-container a', function (event) {
	event.preventDefault()
	// Before navigating to the new game, disable the player so no pointless
	// reconnect is attempted before we navigate away.
	player.socketSystem.disable()
	// Enforce navigation to the new game in this tab, despite any potential intent to
	// open in a new tab, to avoid being left with a disabled player.
	window.location.assign(this.href)
})

export const createBasicUI = () => {
	logger.info('createBasicUI()')
	return {
		init: (configure: () => void) => {
			function onActive() {
				player.elementSystem.init({ analyse: false })

				// Visualisations.
				visualisation.add('global', () => {
					let data = player.audioEffectSystem.analyser.getData()
					visualisation.d3VisualiseFrequencyData(data, '.d3-frequency')
					visualisation.d3VisualiseWaveformData(data, '.d3-waveform')
					return player.audioEffectSystem.analyser.isActive
				})
				visualisation.init()

				// Get local volume and mute elements.
				const volume = $('#volume')
				const mute = $('#mute')

				// Local volume control events.
				$(document)
					.on('input', '#volume', event => {
						player.audioSystem.setLocalVolume(volume.val() as number / 100, { fadeDuration: 0 })
						logger.debug(`Set volume: ${volume.val()}`)
					})
					.on('change', '#volume', event => {
						// Update mute control.
						if (volume.val() === '0') {
							mute.attr('data-hint', 'Unmute')
						} else {
							mute.attr('data-hint', 'Mute')
							// Not muted. Save current local volume, so we can restore on unmute.
							config.lastLocalVolume = volume.val() as number / 100
						}
						logger.info(`Set volume: ${volume.val()}`)
					})

				// Mute control events.
				$(document).on('click', '#mute', event => {
					if (volume.val() === '0') {
						// Restore last local volume to unmute.
						player.audioSystem.setLocalVolume(config.lastLocalVolume, MUTE_TOGGLE_VOLUME_APPLY)
					} else {
						// Save current local volume and mute.
						config.lastLocalVolume = volume.val() as number / 100
						player.audioSystem.setLocalVolume(0, MUTE_TOGGLE_VOLUME_APPLY)
					}
					volume.trigger('change') // Update mute control
				})

				// Update local volume and mute controls when volume is set via event.
				eventSystem.add('setLocalVolume', (event: CustomEvent) => {
					volume
						.attr('data-hint', `${Math.round(event.detail * 100)}%`)
						.val(event.detail * 100)
				})

				// Set initial local volume and mute control state from config.
				player.audioSystem.setLocalVolume(config.localVolume)
				volume.trigger('change') // Update mute control

				// Share link.
				function showTooltip(elem, msg) {
					const wrapper = $(elem).parent()
					const class_ = wrapper.attr('class')
					const hint = wrapper.attr('data-hint')
					const removeClass = function() {
						wrapper.attr('class', class_)
						wrapper.attr('data-hint', hint)
						wrapper.removeClass('hint--always')
					}
					const timeout = setTimeout(removeClass, 2000)
					wrapper.attr('data-hint', msg).addClass('hint--always hint--top hint--no-animate hint--rounded').on('mouseout', function() {
						removeClass()
						clearTimeout(timeout)
					})
				}

				const shareButton = $('.share .fad')
				if (ClipboardJS.isSupported()) {
					const clipboard = new ClipboardJS(shareButton[0])
					clipboard.on('success', function(event) {
						if (event.text) {
							logger.info('Copy share link.')
							showTooltip(event.trigger, 'Copied!')
						}
					})
				} else {
					shareButton.hide()
				}

				// Show UI.
				$('.status-container').hide()
				$('.basic-ui').show()
			}

			function onInactive() {
				setTimeout(() => {
					$('.status').fadeOut(100, () => {
						$('.status').text('Click to Start').fadeIn(100)
					})
				}, 400)
			}

			player.init({ configure, onActive, onInactive })
		},
	}
}

syrinscape.basicUI ??= createBasicUI()

export const basicUI = syrinscape.basicUI
export default basicUI
